export default __webpack_public_path__ + "static/media/ib_excel.29b76f49.svg";